import React, { FC, useState } from 'react';
import { Text } from '@cubeyou-team/hx-react-components';

import { StanleyQueryHistoryItemMoreActions } from './components';

interface StanleyQueryHistoryListRowProps {
  runId: string;
  title: string;
  onSelect: (runId: string) => void;
}

export const StanleyQueryHistoryListRow: FC<
  StanleyQueryHistoryListRowProps
> = ({ runId, title, onSelect }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div
      className={`relative flex w-full min-w-0 max-w-full pl-2 items-center gap-2 rounded py-2 text-left bg-white hover:bg-hx-light-darker focus-within:bg-hx-light-darker ${
        isMenuOpen ? 'z-10' : 'z-0 hover:z-10 focus-within:z-10'
      }`}
    >
      <div
        role="presentation"
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <StanleyQueryHistoryItemMoreActions
          runId={runId}
          title={title}
          onMenuOpenChange={setIsMenuOpen}
        />
      </div>
      <div
        role="button"
        tabIndex={0}
        className="min-w-0 flex-1 cursor-pointer"
        onClick={() => onSelect(runId)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSelect(runId);
          }
        }}
      >
        <Text size="body" className="min-w-0 flex-1 truncate" title={title}>
          {title}
        </Text>
      </div>
    </div>
  );
};
